import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { AgendarIframeComponent } from './agendar-iframe.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [AgendarIframeComponent],
  imports: [
    CommonModule,
    NgbModalModule,
    FormsModule,
    FullCalendarModule,
  ],
  entryComponents: [
    AgendarIframeComponent
  ]
})
export class AgendarIframeModule { }
